export default __webpack_public_path__ + "static/media/rs-arte-14.2e302db1.webp";